import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coachList: [],         // array of coaches
  coachListLoaded: false // so we don't refetch
};

const otherCoachesActivitiesSlice = createSlice({
  name: "otherCoachesActivities",
  initialState,
  reducers: {
    storeCoachList(state, action) {
      state.coachList = action.payload;
      state.coachListLoaded = true;
    },
    resetCoachList(state) {
      state.coachList = [];
      state.coachListLoaded = false;
    },
  },
});

export const {
  storeCoachList,
  resetCoachList
} = otherCoachesActivitiesSlice.actions;

export default otherCoachesActivitiesSlice.reducer;
